import { createLucideIcon } from 'lucide-react';
// The Lean In Circles mark — Lucide has no overlapping-circles glyph. Shared by
// the `Icon` name registry and the `I` map so both render one drawing. Spans
// x 2–22 (Lucide's live area) so it carries the same optical weight as the
// library glyphs it sits beside.
export const Circles = createLucideIcon('circles', [
    ['circle', { cx: '8.5', cy: '12', r: '6.5', key: 'left' }],
    ['circle', { cx: '15.5', cy: '12', r: '6.5', key: 'right' }],
]);
//# sourceMappingURL=Circles.js.map